import {
  apiRequest,
  skpTunjanganKhususList,
  exportExcel,
  masterWorkUnit,
  listAtasan,
  checkSkp,
  checkverification
} from "../../../../../services/adapters/kepegawaian/skpTunjanganKhususService";

class DataTableRepository {
  fetchRowTable = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      skpTunjanganKhususList,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchWorkUnit = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      masterWorkUnit,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchAtasan = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      listAtasan,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchExport = async (query) => {
    return await apiRequest(
      "get",
      exportExcel,
      {
        params: query,
      },
      true
    );
  };
  fetchCheckSkp = async (query) => {
    return await apiRequest(
      "post",
      checkSkp,
      {
        params: query,
      },
      true
    );
  };
  fetchCheckVerifikasi = async (query) => {
    return await apiRequest(
      "post",
      checkverification,
      {
        params: query,
      },
      true
    );
  };
}
export default DataTableRepository;
